import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAPIState, IInfoBlockItemType } from "shared/types";

import { clearActionMeta, dataMetaSelector, editInfoBlockItem } from "Venues/state";

import { VENUE_ACTIONS } from "Venues/types";
import { EditInfoBlockItemModal as Component } from "shared/components";
import { EditInfoBlockItemBaseProps, useEditInfoBlockItem } from "shared/utils";

export const EditInfoBlockItemModal: React.FC<EditInfoBlockItemBaseProps> = ({
  type,
  item,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(VENUE_ACTIONS.editInfoBlockItem));

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(VENUE_ACTIONS.editInfoBlockItem));
    }
  }, [apiMeta?.status, dispatch]);

  useEffect(() => {
    // Clean up error message on modal unmount
    return () => {
      dispatch(clearActionMeta(VENUE_ACTIONS.editInfoBlockItem));
    };
  }, [dispatch]);

  const handleSubmit = async (editedItem: Partial<IInfoBlockItemType>) => {
    if (item?.id) {
      dispatch(editInfoBlockItem({ id: item.id, item: editedItem, type }));
    }
  };

  const { itemReadbleName, formProps, Form } = useEditInfoBlockItem({
    type,
    item,
    handleClose,
    handleSubmit,
    editItemApiStatus: apiMeta?.status,
    editItemApiError: apiMeta?.error,
  });

  return (
    <Component
      type={type}
      handleClose={handleClose}
      itemReadbleName={itemReadbleName}
      componentProps={formProps}
      Component={Form()}
    />
  );
};
